
export function ValuesSection() {
  const values = [
    {
      icon: 'ri-shield-user-line',
      title: 'People-First Security',
      description: 'We believe cybersecurity should empower people, not overwhelm them with complexity.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Accessibility',
      description: 'Every UK business deserves enterprise-grade protection, regardless of size or budget.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Continuous Innovation',
      description: 'We constantly evolve our AI to stay ahead of emerging threats and attack patterns.'
    },
    {
      icon: 'ri-team-line',
      title: 'Local Understanding',
      description: 'Our UK-focused approach ensures we understand the unique challenges facing British SMEs.'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Education-Driven',
      description: 'We turn security incidents into learning opportunities, building stronger cyber awareness.'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Exceptional Support',
      description: 'Our Manchester-based team provides personalized support when you need it most.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Our Values
            </h2>
            <p className="text-xl text-gray-400">
              The principles that guide everything we do at Driscop
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-blue-500/200/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${value.icon} text-blue-400 text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-4">
                  {value.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
